import * as postMenuSearchV1 from 'api/menu/PostMenuSearchV1';
import TagCategory from 'classes/Menu/Search/TagCategory';
import * as Icon from 'types/Icon/Icon';

export default class Tag {
	id: string = '';
	iconSvgUrl: string = '';
	display: boolean = false;
	name: string = '';
	tagCategory: TagCategory = new TagCategory();

	public constructor(input?: postMenuSearchV1.Tag) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public mapToIcon(): Icon.Type | null {
		if (this.display) {
			return {
				name: this.name,
				iconSvgUrl: this.iconSvgUrl,
			};
		}
		return null;
	}

	public mapFromApi(input: postMenuSearchV1.Tag): void {
		this.id = input.id;
		this.iconSvgUrl = input.iconSvgUrl ?? '';
		this.display = input.display;
		this.name = input.name ?? '';
		this.tagCategory.mapFromApi(input.tagCategory);
	}
}
